// extracted by mini-css-extract-plugin
export default {"audioBooksContainer":"AudioBooks_audioBooksContainer__rTREy","carouselDiv":"AudioBooks_carouselDiv__QYi70","carouselContainer":"AudioBooks_carouselContainer__gOpJk"};